import { getState, setState } from 'Utils/Store';
import { createEvergentUser, getProrate } from 'Api/AccountApi';

export const checkoutInitialState = {
  totalTax: 0,
  isTaxError: false,
  billingAddress: {},
  hasShippingAddress: false,
  shippingAddress: null,
  shouldHavePaymentAccount: false,
  paypalError: '',
  successfulPaymentCompleted: false,
};

export const taxUnavailable = () => {
  setState('checkout', { totalTax: 0, isTaxError: true });
};

export const resetTax = () => {
  setState('checkout', { totalTax: 0, isTaxError: false, billingAddress: {} });
};

export const updateShippingAddress = (payload) => {
  setState('checkout', { hasShippingAddress: true, shippingAddress: payload });
};
export const resetShippingAddress = () => {
  setState('checkout', { hasShippingAddress: false, shippingAddress: null });
};

export const setPaypalError = (payload) => {
  setState('checkout', { paypalError: payload });
};

export const successfulPayment = () => {
  setState('checkout', {
    successfulPaymentCompleted: true,
  });
};

export const clearCheckout = () => {
  setState('checkout', checkoutInitialState);
};

const updateTax = (payload) => {
  const { totalTax = 0, isTaxError = false, billingAddress = {} } = payload;
  setState('checkout', { totalTax, isTaxError, billingAddress });
};

const createPaymentAccountSuccess = () => {
  setState('checkout', { shouldHavePaymentAccount: true });
};

export const updateTaxByZip = ({
  GetProrateWithTaxResponseMessage: { responseCode = '0', totalTax = 0, isTaxError = false, billingAddress },
}) => {
  updateTax({ totalTax, isTaxError: isTaxError || responseCode === '0', billingAddress });
};

export const getTaxByZip = async (zipCode) => {
  const {
    plans: { selectedPlan },
  } = getState();

  const { planId } = selectedPlan;

  return getProrate({
    serviceID: planId,
    zipCode,
  })
    .then((res) => res.data)
    .then((data) => {
      // TODO: middleware proxy does not return "isTaxError" property, add on BE response
      const { totalTax = 0, isTaxError = false, billingAddress } = data;
      updateTax({ totalTax, isTaxError, billingAddress });
    });
};

//This creates an Evergent account for Fox users that don't have one
//E.g. for a user that made a free Fox account on Fox Sports
export const createPaymentAccount = async () => {
  await createEvergentUser();
  createPaymentAccountSuccess();
};
